<template>
  <div class="imgexhibite">
  
    <div class="mask">
		<el-image class="imgcenter" fit="cover" @click="" :src="getFileAccessHttpUrl(imgurl)" alt="" ></el-image>
		<div class="skip" @click="closeheadle">跳过{{count}}</div>
	</div>
   
  </div>
</template>

<script>
export default {
  name: "imgexhibite",
  data: function() {
    return {
		imgurl:"",
		timer:null,
		count:5
    };
  },
  
  mounted(){
	    this.getimgurl()
		this.getCode()
  },
  
  methods:{
	    getimgurl() {
			var that = this;
			this.httpGet("web/thpWebCarousel/list", { type: 1 }).then(res => {
			    this.imgurl = res.result[0].fileId;
			});
		},
		
		getCode() {
		    this.timer = setInterval(()=>{
		        this.count--
		        if(this.count===0){
					this.$emit("showheadle")
					clearInterval(this.timer)
		        }
		    },1000)
		},
		
		closeheadle(){
			this.$emit('showheadle');
			clearInterval(this.timer)
		},
		
		
  },
  
};
</script>

<style scoped="scoped" lang="scss">
.imgexhibite{
	width: 100vw;
	height: 100vh;
	.mask {
		width: 100%;
		height: 100%;
		  position: fixed;
		  top: 0;
		  left: 0;
		  // background-color: #000000;
		  // opacity: 0.3;
		  z-index: 100;
		  .imgcenter{
			 width: 100%;
			 height: 100%;
		  }
		  .skip{
			    position: absolute;
			    right: 40px;
			    top: 40px;
			    font-size: 20px;
			    color: #fff;
			    cursor: pointer;
		  }
	}
	
}	



</style>
